const MaliSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_111836)">
      <path
        d="M26.9563 1.24398C24.7897 0.440078 22.4462 0 19.9998 0C17.5534 0 15.21 0.440078 13.0433 1.24398L11.3042 20L13.0433 38.756C15.21 39.56 17.5534 40 19.9998 40C22.4462 40 24.7897 39.56 26.9563 38.756L28.6954 20L26.9563 1.24398Z"
        fill="#FFDA44"
      />
      <path
        d="M40.0001 20.0011C40.0001 11.4018 34.5726 4.0709 26.9565 1.24512V38.7572C34.5726 35.9312 40.0001 28.6004 40.0001 20.0011Z"
        fill="#D80027"
      />
      <path
        d="M0 20.0011C0 28.6004 5.4275 35.9312 13.0435 38.7571V1.24512C5.4275 4.0709 0 11.4018 0 20.0011Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_111836">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default MaliSvg;
